import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

const overrideStyle = makeStyles((theme) => ({
    ul: {
      padding: 0
    },
    li: {
        padding: '4px 24px'
    }
  }), {name: "RaymanNavList"});

function NavList(props)
{
    const classes = overrideStyle();
    const children = Array.isArray(props.children) ? props.children.map((child, index) => (<li className={classes.li} key={index}>{child}</li>)) : <li className={classes.li}>{props.children}</li>
    return <nav>
        <ul className={classes.ul}>
        { children }
        </ul>
    </nav>
}

export default NavList;